export const QUERIES = {
  USER_ME: 'user-me',
  ARTICLE_LIST: 'article-list',
  ARTICLE_DETAIL: 'article-detail',
  ARTICLE_LANGUAGE_DETAIL: 'article-language-detail',
  GET_ADMIN_CATEGORIES_FILTER: 'get-admin-categories-filter',
  ADMIN_CATEGORY_DETAIL: 'admin-category-detail',
  ADMIN_LOCATION_GROUP_DETAIL: 'admin-location-group-detail',
  DOCTOR_LIST: 'doctor-list',
  BANNER_LIST: 'banner-list',
  BANNER_DETAIL: 'banner-detail',
  DOCTOR_DETAIL: 'doctor-detail',
  ADMIN_LOCATION_LIST: 'admin-location-list',
  ADMIN_LOCATION_DETAIL: 'admin-location-detail',
  ADMIN_LOCATION_SERVICE_LIST: 'admin-location-service-list',
  ADMIN_LOCATION_SERVICE_DETAIL: 'admin-location-service-detail',
  ADMIN_LOCATION_LABEL_LIST: 'admin-location-label-list',
  ADMIN_LOCATION_LABEL_DETAIL: 'admin-location-label-detail',
  ADMIN_MAIN_PAGE_VIDEO_LIST: 'admin-main-page-video-list',
  ADMIN_MAIN_PAGE_VIDEO_DETAIL: 'admin-main-page-video-detail',
  LOCATION_GROUP_LIST: 'location-group-list',
  ADMIN_MAIN_PAGE_DOCTOR_LIST: 'admin-main-page-doctor-list',
  ADMIN_OUR_DOCTOR_PAGE_DOCTOR_LIST: 'admin-our-doctor-page-doctor-list',
  ADMIN_PROMOTION_LIST: 'admin-promotion-list',
  ADMIN_PROMOTION_DETAIL: 'admin-promotion-detail',
  ADMIN_PROMOTION_LANGUAGE_DETAIL: 'admin-promotion-language-detail',
  ADMIN_LOCATION_IMAGE_LIST: 'admin-location-image-list',
  ADMIN_LOCATION_IMAGE_DETAIL: 'admin-location-image-detail',
  ADMIN_LOCATION_REVIEW_LIST: 'admin-location-review-list',
  ADMIN_LOCATION_HAS_SERVICE_LIST: 'admin-location-has-service-list',
  ADMIN_MAIN_PAGE_LOCATION_GROUP_LIST: 'admin-main-page-location-group-list',
}
